import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ProgressBarDetails } from '../../api/models/ProgressBarDetails';
import { SessionRequest } from '../../api/models/SessionRequest';
import { SessionResponse } from '../../api/models/SessionResponse';
import { ApiErrorCode, RouteURLConstants, ServiceURLConstants } from '../../constants/upplm.constants';
import { AddClientKeyRequest, AddClientKeyResponse } from '../../interface/upplm.clientKey';
import { TranslateDataPipe } from '../../pipes/translation.pipe';
import { UpplmApiService } from '../../services/upplm.api.services';
import { UpsCommonService } from '../../services/upplm.common.service';
import { ProgressBarService } from '../../services/upplm.progressbar.service';
import { UpplmSessionService } from '../../services/upplm.session.service';
import { UpsDialogComponent } from '../commonComponent/ups-dialog/ups-dialog.component';

@Component({
    selector: 'placardaddclientkey',
    template: require('./placardAddClientKey.component.html')
})

export class PlacardAddClientKeyComponent implements OnInit {

    @ViewChild('messages', { static: false }) errorMessagesServer: UpsDialogComponent;
    @ViewChild('sessionnTimeOut', { static: false }) sessionnTimeOut: UpsDialogComponent;
    sessionData: SessionResponse;
    public showAddedClientKey: boolean = true;
    public messagesErrorServer: string = '';
    public sessionnTimeOutTitle: string = '';
    public placardId: string = '';
    public isLoadding: boolean;
    public pbDetails: ProgressBarDetails;

    constructor(
        private router: Router,
        private _sessionService: UpplmSessionService,
        private _commonService: UpsCommonService,
        private _apiService: UpplmApiService,
        private _pbService: ProgressBarService,
        private _translateData: TranslateDataPipe
    ) { }

    ngOnInit() {
        this.sessionnTimeOutTitle = this._translateData.transform("upplm.common.sessiontimedouttitle");
        this.sessionData = this._sessionService.sessionData;
        this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), this.createSessionRequest()).subscribe((response: SessionResponse) => {
            if (response.commonResponse.isSuccess && response.key) {
                this.sessionData = response;
                if (this.sessionData.locationDetails === null) {
                    this.goToLocation();
                }
                this._sessionService.mapSessionResponse(response);
            } else {
                this.messagesErrorServer = this._translateData.transform("upplm.common.serviceerror");
                this.openModel();
            }
        });
    }

    public backPage() {
        this.pbDetails = new ProgressBarDetails();
        this._pbService.pb = this.pbDetails;
        this._pbService.pb.showStatusBar = true;
        this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_LOCATIONS_DETAILS_ROUTE);
    }

    public clientKeyAdded() {
        let url = this._commonService.createURL(ServiceURLConstants.ADD_CLIENT_KEY + '/' + this.sessionData.placardID, ApiErrorCode.ADD_CLIENT_KEY);
        let body: AddClientKeyRequest = {
            clientKey: this.sessionData.locationDetails.clientKey
        };
        this.isLoadding = true;
        this._apiService.PostServiceAPIObject(url, body).subscribe((response: AddClientKeyResponse) => {
            this.isLoadding = false;
            if (response.errors !== null) {
                if (response.errors[0].message !== '' || response.errors[0].message !== null) {
                    this.messagesErrorServer = response.errors[0].message;
                    this.openModel();
                    return;
                }

            } else {
                if (response.updateResult) {
                    this.placardId = response.placardId;
                    this.showAddedClientKey = false;
                }
            }
        })
    }

    public cancel() {
        this._sessionService.cleanSessionData(this._commonService.createURL(ServiceURLConstants.CLEAN_SESSION, ApiErrorCode.CLEAN_SESSION)).subscribe((response: any) => {
            this._pbService.pb = new ProgressBarDetails();
            this._pbService.pb.showStatusBar = false;
            this._sessionService.mapSessionResponse(response);
            this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_DASHBOARD_ROUTE);
        });
    }

    private goToLocation() {
        this._pbService.pb = new ProgressBarDetails();
        this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_LOCATIONS_DETAILS_ROUTE);
    }

    private validateSessionAndNavigate(target: string) {
        if (!this._sessionService.isValidSession()) {
            this.openSessionTimeOutModel();
        }
        else {
            this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), this.createSessionRequest()).subscribe((response: SessionResponse) => {
                if (response.commonResponse.isSuccess) {
                    this._sessionService.mapSessionResponse(response);
                    this.router.navigateByUrl(target);
                }
            });
        }
    }

    private createSessionRequest(): SessionRequest {
        let request: SessionRequest = new SessionRequest();
        request.key = this.sessionData.key;
        request.locationDetails = this.sessionData.locationDetails;
        request.temporaryLocation = this.sessionData.temporaryLocation;
        request.contactDetails = this.sessionData.contactDetails;
        request.placardDetails = this.sessionData.placardDetails;
        request.pickupDetails = this.sessionData.pickupDetails;
        request.notificationDetails = this.sessionData.notificationDetails;
        request.lastTimeSessionReqired = new Date().toString();
        request.placardID = this.sessionData.placardID;
        return request;
    }

    public openModel() {
        this.errorMessagesServer.open();
    }

    public closeModal() {
        this.errorMessagesServer.close();
    }

    private openSessionTimeOutModel() {
        this.sessionnTimeOut.open();
    }

    public closeSessionTimeOutModal() {
        this._sessionService.cleanSessionData(this._commonService.createURL(ServiceURLConstants.CLEAN_SESSION, ApiErrorCode.CLEAN_SESSION)).subscribe((response: any) => {
            this._sessionService.mapSessionResponse(response);
            document.location.href = `https://www.ups.com/${this._commonService.locale_country.toLocaleLowerCase()}/${this._commonService.locale_lang.toLocaleLowerCase()}/pagenotfound.page`;
            this.sessionnTimeOut.close();
        });
    }
}